export default {"src":"/_next/static/media/georgia.242b086c.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};